import logsTableTemplate from './ezyLogsTable.html';

export default function ezyLogsTableDirective($scope) {/* @ngInject */
  Controller.$inject = ['$scope'];
  function Controller($scope) {
    $scope.toggleLog = function (index) {
      $scope.showLogJson[index] = !$scope.showLogJson[index];
    };

    $scope.showJson = function (json, path) {
      if ($scope[path]) {
        $scope[path] = null;
      } else {
        $scope[path] = json;
      }
    };

    $scope.resetJson = function (value) {
      $scope.showLogJson = Array($scope.logs ? $scope.logs.length : 0).fill(value);
    };
    $scope.resetJson(false);
  }
  return {
    restrict: 'AE',
    scope: {
      logs: '=',
      label: '=',
    },
    controller: Controller,
    template: logsTableTemplate
  };
}

ezyLogsTableDirective.$inject = [];



// WEBPACK FOOTER //
// ./client/app/directives/ezyLogsTable.js